import React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import { tokens } from '../../theme/tokens';

export const PageHeader: React.FC<{
  title: string;
  subtitle?: string;
  chips?: Array<{ label: string; color?: 'default' | 'primary' | 'secondary' }>;
  actions?: React.ReactNode;
}> = ({ title, subtitle, chips, actions }) => {
  return (
    <Box
      sx={{
        mb: 3,
        pb: 2,
        borderBottom: `1px solid ${tokens.color.border}`,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: { xs: 'stretch', md: 'flex-end' },
        gap: 2,
        flexWrap: 'wrap',
      }}
    >
      <Box sx={{ minWidth: 0 }}>
        <Typography variant="h4" sx={{ fontWeight: 700, fontSize: { xs: 22, md: 26 }, letterSpacing: '-0.02em' }}>
          {title}
        </Typography>
        {subtitle ? (
          <Typography variant="body2" sx={{ mt: 0.5, color: tokens.color.textSecondary, maxWidth: 720 }}>
            {subtitle}
          </Typography>
        ) : null}
        {chips?.length ? (
          <Stack direction="row" spacing={1} sx={{ mt: 1, flexWrap: 'wrap', gap: 1 }}>
            {chips.map((c) => (
              <Chip key={c.label} size="small" variant="outlined" label={c.label} />
            ))}
          </Stack>
        ) : null}
      </Box>

      {actions ? <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap' }}>{actions}</Box> : null}
    </Box>
  );
};
